import { Trans } from '@lingui/macro'
import { Alert, Stack } from '@mui/material'

import { useAppSelector } from '@/redux/rootReducer'
import { selectDMPConnectOk, selectDMPConnectTlsiConnectorId } from '@/redux/reducers/dmp-connect.reducer'

import { CheckDMPConnect } from './CheckDMPConnect'
import { DmpConnectDcParameter } from './DmpConnectDcParameter'
import { DmpConnectSession } from './DmpConnectSession'
import { TlsiConnectorConfig } from './TlsiConnectorConfig'
import { DmpConnectVersion } from './DmpConnectVersion'

type DmpConnectProps = {
  onOpenDMPAndMSS?: () => void
}

export function DmpConnect({ onOpenDMPAndMSS }: DmpConnectProps) {
  const connectorOk = useAppSelector(selectDMPConnectOk)
  const tlsiConnectorId = useAppSelector(selectDMPConnectTlsiConnectorId)

  if (!connectorOk) return <CheckDMPConnect />

  return (
    <>
      <DmpConnectVersion />
      <DmpConnectDcParameter>
        <DmpConnectSession>
          <Stack spacing={2}>
            {tlsiConnectorId && (
              <Alert severity="success">
                <Trans>You are connected to DMP Connect</Trans>
              </Alert>
            )}
            <TlsiConnectorConfig />
          </Stack>
        </DmpConnectSession>
      </DmpConnectDcParameter>
    </>
  )
}
